import { useMemo } from 'react';
import { useAuth } from './auth';

/** Матрица прав ролей (Настройки → «Права ролей», 29.10.2026). Источник истины — сервер (/auth/me → perms);
 * здесь только скрываем пункты меню и кнопки. Списки повторяют backend/market/services/perms.py. */
export const AREAS = ['dashboard', 'partners', 'import', 'catalog', 'specifications', 'purchase_orders', 'feedback', 'settings', 'users'] as const;
export const ACTIONS = ['publish_prices', 'second_approval', 'send_to_site', 'sign_contracts', 'zoho_sync'] as const;
export const LEVELS = ['none', 'read', 'write'] as const;
export type Area = (typeof AREAS)[number];
export type Action = (typeof ACTIONS)[number];
export type Level = (typeof LEVELS)[number];
export type RolePerms = { areas: Record<Area, Level>; actions: Record<Action, boolean> };
export type PermMatrix = Record<string, RolePerms>;

const rank = (l: Level | undefined) => (l ? LEVELS.indexOf(l) : 1);

export function usePerms() {
  const { me } = useAuth();
  return useMemo(() => {
    const admin = me?.side === 'staff' && me.role === 'admin';
    const perms = me?.perms ?? null;
    return {
      admin,
      /** доступ к разделу: без данных с сервера — чтение, как было до матрицы */
      can: (area: Area, level: Level = 'read') => admin || (me?.side === 'staff' && rank(perms?.areas?.[area]) >= rank(level)),
      /** отдельное действие (публикация прайса, второе согласование, отправка на сайт, договоры, Zoho) */
      action: (a: Action) => admin || Boolean(perms?.actions?.[a]),
    };
  }, [me]);
}
